import React from "react";

import { Drawer } from "@ui/Molecules";

import { GenericPortal } from "@containers/GenericPortal";

import { DrawerManagerProvider } from "./DrawerManager.context";
import { useManager } from "./DrawerManager.hooks";
import { DrawerManagerComponentWWW } from "./DrawerManager.types";

export const DrawerManager: DrawerManagerComponentWWW = ({
  id,
  onClose,
  ...props
}) => {
  const drawer = useManager();

  React.useEffect(() => {
    drawer.registerCloseHandler(id, () => {
      onClose?.();
    });
  }, [onClose]);
  return (
    <GenericPortal.Portal type="drawer">
      {drawer.isDrawerActive(id) && (
        <Drawer onRequestClose={drawer.hideDrawer.bind(null, id)} {...props} />
      )}
    </GenericPortal.Portal>
  );
};

DrawerManager.Provider = DrawerManagerProvider;
DrawerManager.useManager = useManager;
